<template>
    <div class="famous-pedia-create-form">
        <!-- 0. 状态提示栏 -->
        <div class="famous-pedia-cf-content famous-pedia-note-bar" v-if="!hideNote && (curPediaBaziBaseData.f_status == 1 || curPediaBaziBaseData.f_status == 2)" v-bind:class="'famous-pedia-note-bar-' + curPediaBaziBaseData.f_status">
            <p>{{noteData[curPediaBaziBaseData.f_status] + (curPediaPipanMyData && curPediaPipanMyData.f_msg ? curPediaPipanMyData.f_msg : (curPediaBaziInfo.f_msg ? curPediaBaziInfo.f_msg : '')) }}</p>
            <span class="famous-pedia-note-bar-close" @click="clickNoteClose">
                <span><i class="iconfont icon-guanbi"></i></span>
            </span>
        </div>
        <!-- 1. 编辑修改原因 -->
        <div class="famous-pedia-cf-content" v-if="(curPediaEditType == 'edit' && curPediaPipanMyData) || curPediaEditType == 'modify'">
            <div class="famous-pc-title">
                <span class="famous-pcs-title">修改原因</span>
            </div>
            <div class="famous-pedia-create-edit-panel">
                <comment-edit-panel
                    v-bind:fromPage="'famousCreateForm'"
                    v-bind:textValue="curPediaPipanModifyRemark"
                    v-bind:textId="'remark'"
                    v-bind:hideShowAll="curPediaEditType != 'edit'"
                    v-bind:saveFunc="clickSaveRemark">
                </comment-edit-panel>
            </div>
        </div>
        <!-- 2. 名人简介 -->
        <div class="famous-pedia-cf-content">
            <div class="famous-pc-title">
                <span class="famous-pcs-title">名人简介</span>
                <span class="famous-pcs-edit-box" v-if="curPediaEditType == 'modify' && !modifyBaseInfo">
                    <span class="famous-pcs-edit" @click.stop="clickModify">修改</span>
                </span>
            </div>
            <div v-if="curPediaPipanInfo.base != '' || curPediaEditType == 'edit'" class="famous-pedia-create-edit-panel">
                <comment-edit-panel
                    v-bind:fromPage="'famousCreateForm'"
                    v-bind:textValue="curPediaPipanInfo.base"
                    v-bind:textId="'base'"
                    v-bind:hideShowAll="true"
                    v-bind:saveFunc="clickSaveBase"
                    v-bind:hideEdit="curPediaEditType != 'edit'">                
                </comment-edit-panel>
            </div>
            <div v-if="curPediaEditType == 'modify' && modifyBaseInfo" class="famous-pedia-create-edit-panel">
                <textarea id="modifyBase" class="layout-cep-textarea" v-bind:class="{'layout-cep-textarea-focus' : focused}" @focus="focusTextArea('modifyBase')" @blur="blurTextArea('modifyBase', false)" v-model="textBase" name="base" cols="30" rows="4" placeholder="请输入" maxlength="3000"></textarea>
                <div class="famous-pcs-edit-div">
                    <span class="famous-pcs-edit" @click.stop="clickSaveModifyBase('modifyBase')">保存</span>
                    <span class="famous-pcs-edit" @click.stop="clickCancelModify('modifyBase')">取消</span>
                </div>
            </div>
        </div>
        <!-- 3. 大运流年详细事迹 -->
        <div class="famous-pedia-cf-content" id="dayunliunian">
            <div class="famous-pc-title">
                <span class="famous-pcs-title">大运流年详细事迹</span>
            </div>
            <famous-edit-list></famous-edit-list>
        </div>
    </div>
</template>

<script>
import FamousEditList from './FamousEditList.vue'
import CommentEditPanel from '../../layouts/comment/CommentEditPanel.vue'
import { FAMOUS_DOM } from '../../modules/dom'
import { UA } from '../../modules/utils'
export default {
    name: 'FamousForm',
    components: { FamousEditList, CommentEditPanel  },
    computed: {
        curPediaBaziInfo() {
            return this.$store.state.famouspedia.curPediaBaziInfo
        },
        curPediaBaziBaseData() {
            return this.$store.state.famouspedia.curPediaBaziBaseData;
        },
        curPediaBaziBaseData() {
            return this.$store.state.famouspedia.curPediaBaziBaseData;
        },
        curPediaPipanInfo() {
            return this.$store.state.famouspedia.curPediaPipanInfo;
        },
        curPediaPipanMyData() {
            return this.$store.state.famouspedia.curPediaPipanMyData;
        },
        curPediaEditType() {
            return this.$store.state.famouspedia.curPediaEditType;
        },
        curPediaPipanModifyRemark() {
            return this.$store.state.famouspedia.curPediaPipanModifyRemark;
        }
    },
    data() {
        return {
            hideNote: false,
            noteData: {
                '1': '未通过原因：',
                '2': '已提交审核，正在审核中，需要1-3个工作日，请耐心等待。'
            },
            modifyBaseInfo: false,
            focused: false,
            textBase: ''
        }
    },
    mounted() {
        var me = this;
        setTimeout(() => {
            me.initDom();
        }, 20);
    },
    methods: {
        initDom() {
            var topBarDiv = document.getElementsByClassName('famous-pedia-fate-topbar')[0];
            if(topBarDiv) {
                this.$el.style.paddingTop = topBarDiv.clientHeight + 'px';
                // this.$el.style.paddingBottom = (innerHeight-topBarDiv.clientHeight) + 'px';
            }
        },
        // 保存命盘特点、性格
        clickSaveRemark(text, parentData, cb) {
            this.$store.state.famouspedia.curPediaPipanModifyRemark = text;
        },
        // 保存命盘特点、性格
        clickSaveBase(text, parentData, cb) {
            var me = this;
            var params = { info: { base: text }, cb: cb,
                failCb: function(errMsg) {
                    me.$toast(errMsg);
                }
            };
            this.$store.dispatch('famouspedia/updateBaikePipan', params);
        },
        clickNoteClose() {
            this.hideNote = true;
        },
        clickModify() {
            this.textBase = this.curPediaPipanInfo.base;
            this.modifyBaseInfo = true;
        },
        clickCancelModify(curName) {
            this.textBase = '';
            this.blurTextArea(curName, true);
        },
        clickSaveModifyBase(curName) {
            var me = this;
            this.focused = false;
            this.$store.dispatch('famouspedia/updateBaikePipan', {
                info: {base: this.textBase},
                cb: function() {
                    me.blurTextArea(curName, true);
                },
                failCb: function() {
                    me.$toast('修改失败，请再次尝试！')
                    me.blurTextArea(curName, false);
                }
            });
        },
        focusTextArea(curName) {
            this.focused = true;
            setTimeout(() => {
                if(UA.isIphone()) {
                    FAMOUS_DOM.updateFamousEditFormTextAreaScrollTop(curName, true);
                }else {
                    FAMOUS_DOM.updateFamousEditFormTextAreaScrollTop(curName, false);
                }
            }, 20);
        },
        blurTextArea(curName, hideTextArea) {
            this.focused = false;
            var me = this;
            setTimeout(() => {
                FAMOUS_DOM.updateFamousEditFormTextAreaScrollTop(curName, false);
                me.modifyBaseInfo = !hideTextArea;
            }, 20);
        },
    }
}
</script>